import * as types from './types'

export default {
  [types.INIT_BUSINESS_DATA](state, data) {
    state.business = {
      id: 0,
      shopId: '',
      sid: null,
      statusId: null,
      name: null,
      timezone: null,
      phone: null,
      phoneCC: null,
      billSameAsPrimary: false,
      dispatchPriorityId: null,
      distributorId: null,
      salesRepId: null,
      referralSourceId: null,
      isMobileClient: false,
      isEnterpriseClient: false,
      isAstechClient: false,
      isHunterClient: false,
      isSafeliteClient: false,
      isCorporateAccount: false,
      isCapLinkMember: false,
      isSolera: false,
      soleraSiteIdReference: null,
      isOnyxClient: false,
      onyxClientReference: null,
      useConnect: false,
      capricornNumber: '',
      accountId: null,
      annualRevenueId: null,
      monthlyRoId: null,
      locationCountId: null,
      reportingGroupId: null,
      parentId: null,
      grandparentId: null,
      serialNumber: null,
      source: null,
      externalCustomerId: null,
      manufacturers: [
        /* { id: 0, percent: 0 } */
      ],
      oemCertifications: [
        /* 0 */
      ],
      insuranceDepartments: [
        /* 0 */
      ],
      services: [
        /* 0 */
      ],
      primaryAddress: {
        id: 0,
        street: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        language: 1
      },
      billingAddress: {
        id: 0,
        street: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        language: 1
      },
      users: [
        // {
        //   id: 0,
        //   firstName: null,
        //   lastName: null,
        //   email: null,
        //   password: null,
        //   requiresPasswordOnSubmit: false,
        //   isEnabled: false,
        //   isLockout: false,
        //   receivesInvoices: false,
        //   receivesReports: false,
        //   receivesReportsOnly: false,
        //   receivesChatReports: false,
        //   isAstechUser: false,
        //   titleId: 0,
        //   phone: null
        // }
      ],
      billing: {
        isDemo: false,
        isRecurring: false,
        periodId: null,
        periodAmount: null,
        currencyId: null,
        isCurrencyIdSavedInDatabase: false,
        oemChargeableProducts: []
      },
      promotion: {
        startDate: new Date(),
        endDate: new Date(),
        startProductId: 0,
        endProductId: 0,
        promotionType: 0,
        numberOfScans: 0
      },
      discounts: [
        // {
        //   id: 0,
        //   name: null,
        //   retailPrice: null,
        //   floor: null,
        //   isActive: true,
        //   discount: {
        //     id: 0,
        //     typeId: 0,
        //     amount: null
        //   },
        //   discountByVolume: [
        //     {
        //       id: 0,
        //       typeId: 0,
        //       volumeBreak: null,
        //       isActive: true,
        //       amount: null
        //     },
        //     {
        //       id: 0,
        //       typeId: 0,
        //       volumeBreak: null,
        //       isActive: true,
        //       amount: null
        //     }
        //   ]
        // }
      ],
      notes: [
        // {
        //   id: 0,
        //   text: 'Example',
        //   fileIds: [0],
        //   dateCreated: new Date().toISOString()
        // }
      ]
    }
  },
  [types.SET_DISCOUNT_MODAL](state, modal) {
    state.activeMappingType = modal
    if (modal === null) {
      state.business.discounts = []
    }
  },
  [types.SET_LOADING](state, { button, show }) {
    state.loading[button] = show
  },
  [types.SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab
  },
  [types.SET_BUSINESSES](state, businesses) {
    state.businesses = businesses
  },
  [types.SET_BUSINESS_STATUS](state, data) {
    for (const business of state.businesses) {
      if (business.id === data.id) {
        business.statusId = data.status
        break
      }
    }
  },
  [types.COPY_BILLING_ADDRESS_FROM_DEFAULT](state, address) {
    state.business.billingAddress = address
  },
  [types.SET_BUSINESS_SID](state, sid) {
    state.business.sid = sid
  },
  [types.ADD_NEW_USER_TO_LIST](state) {
    state.business.users.push({
      id: 0,
      firstName: null,
      lastName: null,
      hasLogin: false,
      username: null,
      email: null,
      password: null,
      requiresPasswordOnSubmit: false,
      isPrimary: false,
      isEnabled: false,
      isLockout: false,
      isDeleted: false,
      isMahle: false,
      receivesInvoices: false,
      receivesReports: false,
      receivesReportsOnly: false,
      receivesChatReports: false,
      isAstechUser: false,
      titleId: null,
      phone: null,
      phoneCC: null,
      showRAG: false,
      isTechpro: false,
      isTexa: false
    })
  },
  [types.SET_NEW_USER_ID](state, { user, newId }) {
    const index = state.business.users.findIndex(u => u === user)
    if (state.business.users[index].id === 0) {
      state.business.users[index].id = newId
    }
  },
  [types.ADD_MANUFACTURER](state, manufacturer) {
    state.business.manufacturers.push(manufacturer)
  },
  [types.REMOVE_MANUFACTURER](state, manufacturer) {
    var index = state.business.manufacturers.findIndex(
      x => x.id === manufacturer.id
    )
    state.business.manufacturers.splice(index, 1)
  },
  [types.UPDATE_MANUFACTURER_PERCENT](state, { id, percent }) {
    for (const manufacturer of state.business.manufacturers) {
      if (manufacturer.id === id) {
        manufacturer.percent = percent
        break
      }
    }
  },
  [types.SET_DISTRIBUTORS](state, distributors) {
    // state.distributors = distributors
  },
  [types.SET_SALES_REPS](state, salesReps) {
    // state.salesReps = salesReps
  },
  [types.ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT](state, productIndex) {
    state.business.discounts[productIndex].discountsByVolume.push({
      id: null,
      typeId: null,
      amount: null,
      volumeBreak: null,
      isActive: true
    })
  },
  [types.REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT](
    state,
    { discountIndex, productIndex }
  ) {
    state.business.discounts[productIndex].discountsByVolume.splice(
      discountIndex,
      1
    )
  },
  [types.SET_LOCATION](state, location) {
    state.business.id = location.id
    state.business.sid = location.sid
    state.business.shopId = location.shopId
    state.business.name = location.name
    state.business.timezone = location.timezone
    state.business.phone = location.phone
    state.business.phoneCC = location.phoneCC
    state.business.language = location.language
    state.business.billSameAsPrimary = location.billSameAsPrimary
    state.business.primaryAddress = location.primaryAddress

    state.business.billingAddress = state.business.billSameAsPrimary
      ? location.primaryAddress
      : location.billingAddress
    state.business.billingAddress.state = state.business.billSameAsPrimary
      ? location.primaryAddress.state
      : location.billingAddress.state
  },
  [types.SET_INFO](state, info) {
    if (info) {
      state.business.statusId = info.statusId
      state.business.annualRevenueId = info.annualRevenueId
      state.business.dispatchPriorityId = info.dispatchPriorityId
      state.business.distributorId = info.distributorId
      state.business.accountId = info.accountId
      state.business.monthlyRoId = info.monthlyRoId
      state.business.manufacturers = info.manufacturers || []
      state.business.services = info.services || []

      state.business.isCorporateAccount = info.isCorporateAccount
      state.business.isAstechClient = info.isAstechClient
      state.business.isMobileClient = info.isMobileClient
      state.business.isHunterClient = info.isHunterClient
      state.business.isSafeliteClient = info.isSafeliteClient
      state.business.isEnterpriseClient = info.isEnterpriseClient
      state.business.isSolera = info.isSolera
      state.business.soleraSiteIdReference = info.soleraSiteIdReference
      state.business.isOnyxClient = info.IsOnyxClient
      state.business.useConnect = info.useConnect
      state.business.onyxClientReference = info.OnyxClientReference
      state.business.isCapLinkMember = info.isCaplinkMember
      state.business.capricornNumber = info.capricornNumber
      state.business.salesRepId = info.salesRepId
      state.business.referralSourceId = info.referralSourceId
      state.business.locationCountId = info.locationCountId
      state.business.oemCertifications = info.oemCertifications || []
      state.business.insuranceDepartments = info.insuranceDepartments || []

      state.business.billing.currencyId = info.billing.currencyId
      state.business.billing.isDemo = info.billing.isDemo
      state.business.billing.isRecurring = info.billing.isRecurring === null ? false : info.billing.isRecurring
      state.business.billing.periodAmount = info.billing.periodAmount
      state.business.billing.periodId = info.billing.periodId

      state.business.reportingGroupId = info.reportingGroupId
      state.business.parentId = info.ParentId
      state.business.grandparentId = info.GrandparentId
      state.business.serialNumber = info.SerialNumber
      state.business.source = info.Source
      state.business.externalCustomerId = info.ExternalCustomerId
    } else {
      state.business.annualRevenueId = null
      state.business.dispatchPriorityId = null
      state.business.distributorId = null
      state.business.accountId = null
      state.business.monthlyRoId = null
      state.business.manufacturers = []
      state.business.services = []

      state.business.isAstechClient = false
      state.business.isMobileClient = false
      state.business.isEnterpriseClient = false
      state.business.isHunterClient = false
      state.business.isSafeliteClient = false
      state.business.isSolera = false
      state.business.soleraSiteIdReference = null
      state.business.salesRepId = null
      state.business.referralSourceId = null
      state.business.locationCountId = null
      state.business.isCapLinkMember = false
      state.business.capricornNumber = null
      state.business.isOnyxClient = false
      state.business.onyxClientReference = null
      state.business.useConnect = false
      state.business.oemCertifications = []
      state.business.insuranceDepartments = []

      state.business.billing.currencyId = null
      state.business.billing.isDemo = false
      state.business.billing.isRecurring = false
      state.business.billing.periodAmount = null
      state.business.billing.periodId = null

      state.business.reportingGroupId = null
      state.business.parentId = null
      state.business.grandparentId = null
      state.business.serialNumber = null
      state.business.source = null
      state.business.externalCustomerId = null
    }
  },
  [types.SET_USERS](state, users) {
    state.business.users = users || []
  },
  [types.SET_BILLING](state, billing) {
    state.business.billing = billing
    state.business.billing.oemChargeableProducts = billing.oemChargeableProducts || []
    state.business.billing.isCurrencyIdSavedInDatabase = billing.currencyId > 0
    state.business.billing.initialCurrencyId = billing.currencyId
  },
  [types.SET_PROMOTION](state, promotion) {
    if (promotion) {
      state.business.promotion = promotion
      var date = new Date(promotion.startDate)
      var dateStart = '' + date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate()
      date = new Date(promotion.endDate)
      state.business.promotion.startDate = dateStart
      var dateEnd = '' + date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate()
      state.business.promotion.endDate = dateEnd
      console.log(dateStart)
    } else {
      var defaultDate = new Date()

      var dateformat = '' + defaultDate.getFullYear() + '-' + ((defaultDate.getMonth() + 1) > 9 ? '' : '0') + (defaultDate.getMonth() + 1) + '-' + (defaultDate.getDate() > 9 ? '' : '0') + defaultDate.getDate()
      state.business.promotion.endDate = dateformat
      state.business.promotion.startDate = dateformat
      state.business.promotion.startProductId = 0
      state.business.promotion.endProductId = 0
      state.business.promotion.promotionType = 0
      state.business.promotion.numberOfScans = 0
    }
  },
  [types.SET_DISCOUNTS](state, discounts) {
    state.business.discounts = discounts
  },
  [types.SET_DISCOUNTS_PRODUCT_ADDS](state, discounts) {
    state.business.discountsProductAdds = discounts
    state.business.discountsProductAdds.forEach(element => {
      element.isChanged = false
    })
  },
  [types.SET_NOTES](state, notes) {
    state.business.notes = notes
  },
  [types.ADD_NOTE_TO_LIST](state, note) {
    state.business.notes.unshift(note)
  },
  [types.RESET_PERIOD_DATA](state) {
    state.business.billing.periodId = null
    state.business.billing.periodAmount = null
  },
  [types.SET_ROLES](state, roles) {
    state.roles = roles
  },
  [types.SET_BUSINESSES_FOUND](state, found) {
    state.businessesFound = found
  },
  [types.SET_SOURCE](state, source) {
    state.source = source
  },
  [types.SET_ALL_BUSINESSES](state, businesses) {
    state.allBusinesses = businesses
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/business/mutations.js